import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Modal, Row, Col } from 'react-bootstrap';
import * as studentActions from '../../actions/studentsActionCreators';
import * as courseActions from '../../actions/coursesActionCreators';

const STATUS_RESPONSES = {
  INITIAL: 'initial',
  PENDING: 'pending',
  SUCCESS: 'success',
  FAILED: 'failed'
}

const INTERVAL_RATE = 1000 // ms

class DiagnosticsModal extends React.Component {
  
  state = {
    coursesLoaded: false,
    satisfyStatus: STATUS_RESPONSES.INITIAL,
    output: []
  }

  constructor(props) {
    super(props)
    this.onShow = this.onShow.bind(this)
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval)
    }

    // reset to initial state
    this.setState({
      coursesLoaded: false,
      satisfyStatus: STATUS_RESPONSES.INITIAL,
      output: []
    })
  }
  

  async onShow() {

    this.props.courseActions.getAllCourses().then(() => {
      this.setState({ coursesLoaded: true });
    });

      const response = this.props.studentMode
        ? await this.props.courseActions.runSatisfy(this.props.addId)
        : await this.props.studentActions.runSatisfy(this.props.studentId)


      if (response.status !== STATUS_RESPONSES.SUCCESS) {
        this.setState({ satisfyStatus: response.status })
        this.interval = setInterval(async () => {
          const status = await this.props.studentActions.runSatisfyStatusCheck(response.url)
          switch (status.status) {
            case STATUS_RESPONSES.PENDING:
              //do nothing
              break
            case STATUS_RESPONSES.SUCCESS:
            case STATUS_RESPONSES.FAILED:
              this.setState({ satisfyStatus: status.status, output: status.output })
              clearInterval(this.interval)
              break

          }
        }, INTERVAL_RATE)
      }
  }

  renderStatusMessage () {
    const coursesToDrop = this.state.output
      .map((c) => {
      const foundCourse = this.props.courses.find(course => course.id === c)
      return foundCourse ? foundCourse.slug : ''
      }).join(', ')

    switch (this.state.satisfyStatus) {
      case STATUS_RESPONSES.PENDING:
        return 'Please wait... processing request.'
      case STATUS_RESPONSES.SUCCESS:
        return this.state.output.length
          ? `Your request has created one or a combination of the following issues: timing conflict, pre or co-requisite violation, credit limit exceeded, ineligible class. Dropping ${coursesToDrop} could make your schedule valid, but there may be other courses you could drop instead that would also make your schedule valid if you don't want to drop ${coursesToDrop}. Please review course requirements.`
          : this.props.studentMode
            ? 'This request is valid.'
            : 'The student\'s schedule is valid.'
        case STATUS_RESPONSES.FAILED:
        return this.state.output
    }
  }
  
  render() {
    const {onCancel, showModal }= this.props
    return (
      <Modal show={showModal} onHide={onCancel} backdrop="static" className="confirmModal" onShow={this.onShow}>
        <Modal.Header closeButton>
          <Modal.Title>
            <Row>
              <Col md={12} className="modal-title">
                {'Run Diagnostic'}
              </Col>
            </Row>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="mt-3 text-center font-size-20">{this.renderStatusMessage()}</p>
        </Modal.Body>
        <Modal.Footer className="mt-3">
          <button onClick={onCancel} className="btn  btn-ter pull-left">Go Back</button>
        </Modal.Footer>
      </Modal>
    );
  }
}


function mapStateToProps(state) {
  return {
    courses: state.courses
  };
}

function mapDispatchToProps(dispatch) {
  return {
    studentActions: bindActionCreators(studentActions, dispatch),
    courseActions: bindActionCreators(courseActions, dispatch)
  };
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DiagnosticsModal);



// WEBPACK FOOTER //
// ./src/components/common/DiagnosticsModal.js